<template>
  <div>
    <Intro/>
    <SxnOne/>
    <HomeCalendar/>
    <SxnTwo/>
    <SxnThree/>
    <SxnFour/>
    <SxnFive/>
    <SxnCta/>
  </div>
</template>

<script>
import { bus } from '../../main';
import Intro from './Intro';
import SxnOne from './SxnOne';
import HomeCalendar from './HomeCalendar';
import SxnTwo from './SxnTwo';
import SxnThree from './SxnThree';
import SxnFour from './SxnFour';
import SxnFive from './SxnFive';
import SxnCta from '../commons/SxnCta';
export default {
  name: 'home',
  components: {
    Intro,
    SxnOne,
    HomeCalendar,
    SxnTwo,
    SxnThree,
    SxnFour,
    SxnFive,
    SxnCta
  },
  data: () => ({
    
  }),
  mounted () {
    bus.$emit('update-route', this.$route);
  }
};
</script>
